import { useState } from 'react'
import { usePasswordLogin } from '@authentication/mutations/usePasswordLogin'
import { Flex } from 'antd'
import { useSearchParams } from 'react-router-dom'
import { FrontendPlatform, LoginTokens, OtpLogin } from 'types/api'
import { LoginContent } from './LoginContent'
import { HelpLink } from './HelpLink'
import { Button, Password, Form, Modal, FormItem } from 'mysaiva-web-components'
import { useTranslation } from 'react-i18next'
import styles from './Shared.module.scss'
import { AuthSearchParams } from '@authentication/types'

type LoginStepPasswordProps = {
  onSuccess: (tokens: LoginTokens, params: OtpLogin, username: string) => void
  onBackToEmailButtonClick: () => void
}

export function LoginStepPassword(props: LoginStepPasswordProps) {
  const { onSuccess, onBackToEmailButtonClick } = props
  const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false)
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const username = searchParams.get('username') || ''

  const { mutate: passwordLogin, isPending } = usePasswordLogin({}, (data) => {
    onSuccess(
      data,
      {
        email: ''
      },
      username
    )
  })

  function handlePasswordLogin(values: { password: string }) {
    passwordLogin({
      username,
      password: values.password,
      platform: FrontendPlatform.Web
    })
  }

  function handleforgotPassword() {
    setOpenForgotPasswordModal(true)
  }

  function handleBackButtonClick() {
    deleteSearchParams()
    onBackToEmailButtonClick()
  }

  function deleteSearchParams() {
    searchParams.delete(AuthSearchParams.Username)
    searchParams.delete(AuthSearchParams.UsernameLogin)
    setSearchParams(searchParams)
  }

  return (
    <LoginContent
      title={t('login.loginStepPassword.title')}
      subtitle={t('login.loginStepPassword.subtitle', { username: username })}
      footer={<HelpLink />}
    >
      <Form onFinish={handlePasswordLogin} layout="vertical">
        <FormItem
          style={{ paddingTop: '20px', marginBottom: '5px' }}
          name="password"
          label={t('login.loginStepPassword.passwordLabel')}
          rules={[
            {
              required: true,
              message: t('login.loginStepPassword.passwordRequired')
            }
          ]}
        >
          <Password
            className={styles.loginInput}
            style={{ marginBottom: '0px' }}
            placeholder={t('login.loginStepPassword.passwordLabel')}
            shadow={true}
            trim
          />
        </FormItem>
        <Flex justify="end" style={{ marginBottom: 20 }}>
          <Button type="text" size="small" onClick={handleforgotPassword}>
            {t('login.loginStepPassword.forgotPassword')}
          </Button>
        </Flex>
        <FormItem>
          <Button
            loading={isPending}
            disabled={false}
            className={styles.loginButton}
            type="primary"
            htmlType="submit"
            data-testid="login-email-btn"
          >
            {t('login.loginStepPassword.button')}
          </Button>
        </FormItem>
        <Button type="text" onClick={handleBackButtonClick}>
          {t('login.loginStepPassword.backToEmail')}
        </Button>
      </Form>
      <Modal
        open={openForgotPasswordModal}
        onCancel={() => setOpenForgotPasswordModal(false)}
        footer={null}
        width={400}
      >
        <div>
          {t('login.loginStepPassword.contactAdmin')}
        </div>
      </Modal>
    </LoginContent>
  )
}
